module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_nav.584f67be.jpg";